import { Repository } from '@/forms/api/repository-factory';
import getParams from '@/forms/helpers/get-params';
import { COMPANIES } from '@/forms/constants/services';

const MIN_CHARS_TO_FIRE = 1;

const resource = '/customer/getcompanylist/v1.0';

export default {
    async getCompanies(search) {
        if (search.length < MIN_CHARS_TO_FIRE) {
            return { data: [] };
        }
        return Repository.post(`${resource}`, {
            'query-type': 'company',
            'param-type': 'contains',
            'param-detail': search,
        }, {
            params: getParams(COMPANIES),
        });
    },
};